const Testimonials = () => {
  return (
    // <section className="overflow-hidden py-5">
    //   <div className="d-flex mb-n1 text-primary">
    //     <svg
    //       className="w-100"
    //       viewBox="0 0 1440 116"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M0 64.5909H349.922C606.664 64.5909 859.771 -7.62939e-06 1080 -7.62939e-06C1300.23 -7.62939e-06 1440 64.5909 1440 64.5909V116H0V64.5909Z"
    //         fill="currentColor"
    //       ></path>
    //     </svg>
    //   </div>
    //   <div
    //     className="position-relative py-5 bg-primary"
    //     style={{
    //       backgroundImage: "url('/media/images/pattern-dark.png')",
    //     }}
    //   >
    //     <div
    //       className="position-absolute top-0 start-0 h-100 w-100"
    //       style={{
    //         background:
    //           "radial-gradient(50% 50% at 50% 50%, rgba(42, 51, 66, 0) 0%, #2A3342 100%)",
    //       }}
    //     ></div>
    //     <div
    //       className="position-relative container-fluid py-5"
    //       style={{ zIndex: 1 }}
    //     >
    //       <div className="row align-items-center py-3">
    //         <div className="col-auto">
    //           <a className="text-dark-light link-dark-light" href="#">
    //             <svg
    //               width="48"
    //               height="48"
    //               viewBox="0 0 48 48"
    //               fill="none"
    //               xmlns="http://www.w3.org/2000/svg"
    //             >
    //               <circle cx="24" cy="24" r="24" fill="currentColor"></circle>
    //               <path
    //                 d="M28.9999 23H21.4099L24.7099 19.71C24.8982 19.5217 25.004 19.2663 25.004 19C25.004 18.7337 24.8982 18.4783 24.7099 18.29C24.5216 18.1017 24.2662 17.9959 23.9999 17.9959C23.7336 17.9959 23.4782 18.1017 23.2899 18.29L18.2899 23.29C18.1989 23.3851 18.1275 23.4973 18.0799 23.62C17.9799 23.8635 17.9799 24.1365 18.0799 24.38C18.1275 24.5028 18.1989 24.6149 18.2899 24.71L23.2899 29.71C23.3829 29.8037 23.4935 29.8781 23.6153 29.9289C23.7372 29.9797 23.8679 30.0058 23.9999 30.0058C24.1319 30.0058 24.2626 29.9797 24.3845 29.9289C24.5063 29.8781 24.6169 29.8037 24.7099 29.71C24.8036 29.617 24.878 29.5064 24.9288 29.3846C24.9796 29.2627 25.0057 29.132 25.0057 29C25.0057 28.868 24.9796 28.7373 24.9288 28.6154C24.878 28.4936 24.8036 28.383 24.7099 28.29L21.4099 25H28.9999C29.2651 25 29.5195 24.8946 29.707 24.7071C29.8945 24.5196 29.9999 24.2652 29.9999 24C29.9999 23.7348 29.8945 23.4804 29.707 23.2929C29.5195 23.1054 29.2651 23 28.9999 23Z"
    //                 fill="#D5DAE1"
    //               ></path>
    //             </svg>
    //           </a>
    //         </div>
    //         <div className="col px-5">
    //           <div className="row g-5">
    //             <div className="col-12 col-md-6">
    //               <div className="row align-items-center g-6">
    //                 <div className="col-auto">
    //                   <img
    //                     className="img-fluid"
    //                     src="/media/images/avatar.png"
    //                     alt=""
    //                   />
    //                 </div>
    //                 <div className="col">
    //                   <h4 className="mb-2 fs-8 fw-semibold text-white">
    //                     Darren Dunlap
    //                   </h4>
    //                   <p className="mb-0 text-dusk fw-semibold">
    //                     CEO &amp; Founder at Flex.co
    //                   </p>
    //                 </div>
    //               </div>
    //             </div>
    //             <div className="col-12 col-md-5 offset-md-1">
    //               <div className="position-relative mw-md-md ms-md-auto">
    //                 <h4
    //                   className="position-relative mb-0 font-heading fs-8 fw-semibold text-white"
    //                   style={{ zIndex: 1, letterSpacing: -1 }}
    //                 >
    //                   The best solution for anyone who wants to work a flexible
    //                   schedule but still earn a full-time income.
    //                 </h4>
    //                 <img
    //                   className="position-absolute mt-n6 ms-n7"
    //                   src="media/icons/quote-top-dark.svg"
    //                   alt=""
    //                   style={{ top: "-50%", left: "-10%", zIndex: -1 }}
    //                 />
    //                 <img
    //                   className="position-absolute mb-n6 me-n7"
    //                   src="media/icons/quote-down-dark.svg"
    //                   alt=""
    //                   style={{ bottom: "-50%", right: "-10%", zIndex: -1 }}
    //                 />
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //         <div className="col-auto">
    //           <a className="text-dark-light link-dark-light" href="#">
    //             <svg
    //               width="48"
    //               height="48"
    //               viewBox="0 0 48 48"
    //               fill="none"
    //               xmlns="http://www.w3.org/2000/svg"
    //             >
    //               <circle cx="24" cy="24" r="24" fill="currentColor"></circle>
    //               <path
    //                 d="M29.92 23.62C29.8724 23.4973 29.801 23.3851 29.71 23.29L24.71 18.29C24.6168 18.1968 24.5061 18.1228 24.3842 18.0723C24.2624 18.0219 24.1319 17.9959 24 17.9959C23.7337 17.9959 23.4783 18.1017 23.29 18.29C23.1968 18.3832 23.1228 18.4939 23.0723 18.6158C23.0219 18.7376 22.9959 18.8681 22.9959 19C22.9959 19.2663 23.1017 19.5217 23.29 19.71L26.59 23H19C18.7348 23 18.4804 23.1054 18.2929 23.2929C18.1054 23.4804 18 23.7348 18 24C18 24.2652 18.1054 24.5196 18.2929 24.7071C18.4804 24.8946 18.7348 25 19 25H26.59L23.29 28.29C23.1963 28.383 23.1219 28.4936 23.0711 28.6154C23.0203 28.7373 22.9942 28.868 22.9942 29C22.9942 29.132 23.0203 29.2627 23.0711 29.3846C23.1219 29.5064 23.1963 29.617 23.29 29.71C23.383 29.8037 23.4936 29.8781 23.6154 29.9289C23.7373 29.9797 23.868 30.0058 24 30.0058C24.132 30.0058 24.2627 29.9797 24.3846 29.9289C24.5064 29.8781 24.617 29.8037 24.71 29.71L29.71 24.71C29.801 24.6149 29.8724 24.5028 29.92 24.38C30.02 24.1365 30.02 23.8635 29.92 23.62Z"
    //                 fill="#D5DAE1"
    //               ></path>
    //             </svg>
    //           </a>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="d-flex mt-n1 text-primary">
    //     <svg
    //       className="w-100"
    //       viewBox="0 0 1440 116"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M1440 51.4091H1090.08C833.336 51.4091 580.229 116 360 116C139.771 116 0 51.4091 0 51.4091V0H1440V51.4091Z"
    //         fill="currentcolor"
    //       ></path>
    //     </svg>
    //   </div>
    // </section>

    <div className="row">
      <div className="col px-5 py-3">
        <div className="row g-5">
          <div className="col-12 col-md-6">
            <div className="row align-items-center g-6">
              <div className="col-auto">
                <img
                  className="img-fluid"
                  src="/media/images/avatar.png"
                  alt=""
                />
              </div>
              <div className="col">
                <h4 className="mb-2 fs-8 fw-semibold text-white">
                  Darren Dunlap
                </h4>
                <p className="mb-0 text-dusk fw-semibold">
                  CEO &amp; Founder at kantipur
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-5 offset-md-1">
            <div className="position-relative">
              <h4
                className="position-relative mb-0 font-heading fs-8 fw-semibold text-white"
                style={{ zIndex: 1, letterSpacing: -1 }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
